import { Text } from "agrofy-ui-components";
import React from "react";
import styled from "styled-components";

const LabelStyled = styled.div`
  display: flex;
  align-items: center;
  background: ${(props) => props.backColor};
  border-radius: 4px;
  color: ${(props) => props.fontColor};
  font-family: Montserrat, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  padding: 8px 16px;
  cursor: pointer;
`;

const StyledText = styled.div`
  display: flex;
  padding: 0 8px;
`;

const IconButton = ({ icon, text, backColor, fontColor, fontWeigth }) => {
  return (
    <LabelStyled backColor={backColor} fontColor={fontColor}>
      {icon ? (
         <img style={{width: '20px', height: '20px'}} src={icon} />
      ) : null}
      <StyledText>
        <Text type="body-md" weight={fontWeigth} color={fontColor} tag="h2" className={"m-0"}>
          {text}
        </Text>
      </StyledText>
    </LabelStyled>
  );
};

export default IconButton;
